module.exports = __webpack_public_path__ + "img/play-btn.195fb0aa.svg";